// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--rGqql";
export var isLeft = "styles-module--is-left--gJewR";
export var isLeftMobile = "styles-module--is-left-mobile--7XHX5";
export var item = "styles-module--item--7B5yi";
export var items = "styles-module--items--OlJt2";
export var qr = "styles-module--qr--AKHw4";
export var versionDark = "styles-module--version-dark--+tAG5";
export var versionLight = "styles-module--version-light--6Pp+2";